'use es6';

import styled from 'styled-components';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
export default styled(UIDropdown).withConfig({
  displayName: "StyleProtectedUIDropdown",
  componentId: "ax8574-0"
})(["display:block !important;"]);